import React from 'react'
import { Container, TopLogoSection, OrderedList } from './styles'

function ContentAndCommunityGuidelines() {
  return (
    <>
      <TopLogoSection>
        <img src="/images/writer-logo.svg" alt="" />
      </TopLogoSection>
      <Container>
        <h1>Pocket FM Content and Community Guidelines</h1>
        <p>
          These Content and Community Guidelines <b>(“Guidelines”)</b> govern
          your use of our website located at{' '}
          <a href="https://www.pocketnovel.com/" target="_blank">
            https://www.pocketnovel.com
          </a>{' '}
          and/or the Pocket Novel mobile application (collectively, the{' '}
          <b>“Platform”</b>) and is made available by{' '}
          <b>Pocket FM (“we”, “us”</b> and “our”, which terms shall include{' '}
          <b>Pocket FM Corp., Pocket FM Private Limited</b> and/or any of their
          affiliates̵). The terms <b>“you”</b> and <b>“your”</b> refer to the
          user of the Platform.
        </p>
        <p>
          <b>
            These Guidelines shall be read with our Terms of Use{' '}
            <a
              href="https://www.pocketfm.com/terms-and-conditions"
              target="_blank"
            >
              https://www.pocketfm.com/terms-and-conditions
            </a>
            , and our Privacy Policy at{' '}
            <a href="https://www.pocketfm.com/privacy-policy" target="_blank">
              https://www.pocketfm.com/privacy-policy
            </a>
          </b>
          , (collectively, <b>“Terms”</b>). The capitalized words used in these
          guidelines shall have the meaning given to such words in the Terms.
        </p>
        <p>
          Please note that we may change these Guidelines from time to time and
          we reserve the right to do so.
        </p>
        <p>
          At Pocket FM, we value freedom of thought and expression and we
          believe in being an inclusive and empowering Platform that works for
          all our users, allowing them to explore their passion and interests.
          We encourage users to celebrate what makes them unique, while finding
          a community that does the same. We deeply value that our users come
          from a multitude of cultures, and we believe it is important to be
          mindful of the diverse cultural norms and beliefs that our users
          represent. The content and comments that are posted on the Platform
          reflect this diversity and plurality and we aim to build a community
          that is accepting, respectful and at the same time engaging. We
          believe that creating a safe and supportive environment is a top
          priority and that feeling safe is essential to helping people feel
          comfortable with expressing themselves openly and creatively. We also
          aim to cultivate an environment for authentic interactions by keeping
          deceptive content and accounts off our Platform. Keeping in mind these
          values, we have put in place these Guidelines which shall apply to
          your use of the Platform.
        </p>
        <br />
        <h2>GUIDELINES FOR CONTENT</h2>
        <p>
          Any content which violates these Guidelines is not allowed on our
          Platform and we may remove, limit, or block the distribution of such
          content and the accounts, individuals, groups and domains that create
          or spread it based on how much harm it poses. We encourage you to
          report any content that violates these Guidelines which you may come
          across by writing to{' '}
          <a href="mailto:grievances@pocketfm.com" target="_blank">
            grievances@pocketfm.com
          </a>
          .
        </p>
        <p>
          While any intent to cause discomfort, hurt, offend or engage in any
          illegal or abusive behaviour will no doubt be taken seriously, we
          believe that content can be hurtful, cause discomfort or offence even
          without an apparent intent to do so and we encourage you to report
          such content as well.
        </p>
        <OrderedList type="1">
          <li>
            <div>
              {' '}
              <h3>Harassment, Bullying, Exploitation or Hateful Activities</h3>
              <p>
                Our Platform is not a place for abusive behavior, hateful
                content, exploitation of people or animals or harassment of any
                kind. We encourage reporting of any content that harasses
                another person or defames anyone. In particular, we shall limit
                the distribution of or remove such content and accounts,
                including but not limited to:
              </p>
              <ul>
                <li>
                  Posting abuses or curse words, slurs, negative stereotypes,
                  caricatures and generalizations;
                </li>
                <li>
                  Obscene content or any content or remarks which are racist,
                  sexist, degrading or discriminatory towards any person or
                  group;
                </li>
                <li>
                  Malicious recordings, objectifying someone, sexual remarks,
                  making sexual advances or otherwise engaging in sexual
                  misconduct.
                </li>
                <li>Extorting or blackmailing any person;</li>
                <li>
                  Attack on individuals or groups or mocking or attacking the
                  beliefs, sacred symbols, movements, or institutions of
                  individuals or groups based on their actual or perceived race,
                  color, caste, ethnicity, immigration status, national origin,
                  religion or faith, sex or gender identity, sexual orientation,
                  disability or medical condition. If someone blocks you from
                  their account, do not try to contact them from another
                  account.
                </li>
              </ul>
            </div>{' '}
          </li>
          <br />
          <li>
            <h3>Nudity and Pornography</h3>
            <p>
              Our Platform is not a place for pornography. We shall limit the
              distribution of or remove mature and explicit content, including:
            </p>
            <ul>
              <li>
                Content depicting sexually explicit, pornographic or nude
                material;
              </li>
              <li>Content depicting sextortion or revenge pornography;</li>
              <li>
                Content that exploits or endangers any person (for example,
                listing of phone numbers, or sharing information encouraging or
                soliciting prostitution or escort services);
              </li>
              <li>
                Content depicting child pornography (including without
                limitation, creation, transmission or browsing of child
                pornography); or
              </li>
              <li>Content depicting rape, gangrape and molestation.</li>
            </ul>
            <p>
              We do our best to differentiate between pornography and other
              mature content but we may still limit its distribution so people
              don’t run into it accidentally.
            </p>
          </li>
          <li>
            <h3>Hate Speech and hate propaganda</h3>{' '}
            <p>
              We do not allow content that intimidates any person or promotes
              violence against or targets, demeans or offends any particular
              religion, caste, ethnicity, community, disability (physical or
              mental), age or gender. Any kind of content which induces hatred
              or intends to create or spread hatred or hate propaganda along
              lines of religion, caste, ethnicity, community, disability
              (physical or mental) age or gender is also not allowed.
            </p>
            <p>
              Our editorial team reserves the right to evaluate all submissions
              to ensure they adhere to our Guidelines as well as applicable law.
              Any content found to violate these Guidelines will be rejected and
              not considered for publication on the Platform.
            </p>
          </li>
          <li>
            <h3>Violence and disturbing content</h3>{' '}
            <p>
              We may not allow any content that may cause discomfort on account
              of their graphic description or goriness. We may not allow content
              that glorifies violence, or intends to incite violence, or
              encourages dangerous and illegal activities, or condones/praises
              individuals or groups involved in violent and/or criminal
              activities.
            </p>
            <p>
              We recognize that educational or informative content may, on
              occasion, contain violence and the same may be allowed provided
              that it is responsibly captioned in detail and contains warnings
              for its violent content.
            </p>
          </li>
          <li>
            <h3>Intellectual Property rights</h3>{' '}
            <p>
              Songs, music, thumbnails advertisements, jingles, poems,
              limericks, plays, novels, short stories, lectures, speeches,
              articles, software, brand names, logos, tag lines, affiliations,
              and other similar content, are all subject to intellectual
              property protection which shall be governed by our terms of use at
              <a
                href="https://www.pocketfm.com/terms-and-conditions"
                target="_blank"
              >
                https://www.pocketfm.com/terms-and-conditions
              </a>{' '}
              and copyright policy at{' '}
              <a href="https://www.pocketfm.com/copyright " target="_blank">
                https://www.pocketfm.com/copyright
              </a>.
            </p>
            <p>
              You shall not post any content which copies or uses the
              intellectual property of another person or organization, without
              due permission or consent. Always take permission and give due
              credits to users or other individuals if you use their content (or
              any portion thereof) by attributing the same. In particular, we
              shall limit the distribution of or remove such content or
              accounts, including but not limited to:
            </p>
            <ul>
              <li>
                Which infringe the intellectual property right of a third-party,
                including without limitation works of copyright, patents,
                designs, brand names, logos and other proprietary devices and
                signifiers;
              </li>
              <li>
                Which contain any confidential or proprietary information of a
                third-party;
              </li>
              <li>
                Which defame, disparage or constitute negative advertisement of
                any brand or personality.
              </li>
            </ul>
          </li>
          <li>
            <h3>No violation of applicable laws</h3>{' '}
            <p>
              All content that is uploaded, posted, commented on, or shared by
              you (in any manner) on our Platform, must adhere to applicable
              laws of all relevant jurisdictions. We shall cooperate with all
              authorities to the full extent in cases of breach of any laws.
            </p>
          </li>
          <li>
            <h3>Illegal activities</h3>{' '}
            <p>
              We prohibit any content or activity that endorses or promotes the
              violation of applicable laws. Content relating to crime, violence,
              sale of illegal or regulated goods or services, drugs, and
              soliciting or selling of sexual services is strictly forbidden.
            </p>
            <p>
              This includes content that educates users on illegal activities
              such as making bombs or doing drugs. You are not allowed to
              promote, operate, encourage or endorse online gambling, online
              real money games of skill or online lotteries.
            </p>
            <p>
              Impersonation of any person (whether your friends or celebrities
              or brands) and distribution of false or misleading information on
              our Platform intended to make personal or financial gains shall be
              considered fraud and we shall act against the same accordingly.
            </p>
          </li>
          <li>
            <h3>Self-harm, abuse and suicide</h3>{' '}
            <p>
              We do not allow any content related to physical, sexual, or
              psychological maltreatment, neglect or abuse of a person, whether
              a child or an adult. Content relating to self-harm, injury or
              suicide or which provokes or encourages anyone to commit self-harm
              are also not allowed. We also do not allow content that identifies
              or negatively targets the victims or survivors of abuse, assault,
              self-injury or domestic or similar violence.
            </p>
          </li>
          <li>
            <h3>Personal content</h3>{' '}
            <p>
              We shall not allow any kind of personal content of another person,
              including information which such person is not or would not be
              comfortable being posted. We will remove such content forthwith
              and without notice.
            </p>
            <p>
              You are not allowed to share or reveal anyone’s personal data or
              sensitive personal data or information, including without
              limitation, phone number, address, financial information, health
              information and government issued ID etc.
            </p>
          </li>
          <li>
            <h3>Fake News</h3>{' '}
            <p>
              We do not allow content which contains or promotes deliberate
              misinformation or misleading claims. We may also prohibit
              exaggeration or sensationalism which contains non-factual elements
              and may be harmful to users on the Platform.
            </p>
            <p>
              We shall endeavor to distinguish between fake news and
              satire/parody.
            </p>
          </li>
          <li>
            <h3>Spam</h3>{' '}
            <p>
              Any false or misleading advertisements, representations, claims
              and unwanted communication shall fall under the ambit of
              commercial spam, which compromises the quality of user engagement
              on the Platform. Please ensure that the content you share is
              authentic and will help create a safe environment for people to
              use and enjoy the Platform. Do not post content if it may annoy
              users or which is intended to sell goods/services or gain
              followers.
            </p>
          </li>
        </OrderedList>
        <h2>COMMUNITY GUIDELINES</h2>
        <p>
          In order to build an engaging and respectful community on the
          Platform, we require you to follow these norms.
        </p>
        <OrderedList>
          <li>
            <h3>Be polite</h3>
            <p>
              We expect all users to behave with integrity and demonstrate
              courtesy and respect to other users. Rudeness, abusive behavior or
              any participation which is not in good faith shall not be
              tolerated. Be mindful that certain words when translated to
              another language may be offensive. Our Platform is multi-lingual
              and multi-cultural and we expect our users to be mindful of that.
            </p>
          </li>
          <li>
            <h3>Content Repetition</h3>
            <p>
              We prioritize reader satisfaction and discourage repetitive
              content between chapters. Excessive repetition may hinder the
              reading experience and narrative flow. Authors should focus on
              captivating storylines, innovative storytelling techniques, and
              character development to keep readers engaged. Avoiding redundant
              descriptions, excessive reiteration, and repetitive dialogue is
              encouraged. Together, we can create a dynamic, engaging
              environment that values fresh perspectives and high-quality
              content on the Platform.
            </p>
          </li>
          <li>
            <h3>Fake profiles</h3>
            <p>Fake profiles or impersonation is prohibited.</p>
          </li>
          <li>
            <h3>Suspension</h3>
            <p>
              In case your account is suspended or blocked by us, you shall not
              attempt to circumvent the suspension by using other accounts,
              identities, personalities or through another user's account. In
              such circumstances, we may be compelled to terminate your account
              and block you from registering with us.
            </p>
          </li>
          <li>
            <h3>Applicable laws</h3>
            <p>
              Users must comply with applicable laws that govern their online
              conduct at all times. Any activity featuring, encouraging,
              offering or soliciting illegal activities will not be tolerated.
              Being unaware of the law is not an excuse.
            </p>
          </li>
        </OrderedList>
        <h2>REPORTING</h2>
        <p>
          If you see any content or activity that violates these Guidelines,
          please email us on{' '}
          <a href="mailto:grievances@pocketfm.com" target="_blank">
            grievances@pocketfm.com
          </a>{' '}
          and provide us with the URL of such content. If we find the content or
          activity to be a violation of the Guidelines or otherwise unsuitable
          for our Platform, we will remove it. If you believe any content
          infringes your intellectual property rights (please see point (d)
          above), you can file a claim at{' '}
          <a href="mailto:legal@pocketfm.com" target="_blank">
            legal@pocketfm.com
          </a>{' '}
          for our team to review and we will consider taking down the same (if
          required) in accordance with applicable laws. It may take some time to
          take down such content, so please bear with us.
        </p>
        <br />
        <h2>INTERMEDIARY STATUS</h2>
        <p>
          We are an intermediary in relation to the Pocket Novel Platform. We do
          not direct or control the actions, words or content of our users and
          are not responsible for their (or your) actions either on the Platform
          or otherwise. We are not responsible for services and features offered
          by others even if you access them through our Platform.
        </p>
        <br />
        <h2>CHALLENGE OF DECISION</h2>
        <p>
          In case your content or your account is removed or suspended from our
          Platform, you may write to us at{' '}
          <a href="mailto:writers@pocketfm.com" target="_blank">
            writers@pocketfm.com
          </a>{' '}
          to challenge the removal. We may review the content again and
          determine if it may be reposted on the Platform at our sole
          discretion.
        </p>
        <br />
        <h2>ACTIONS AGAINST TRANSGRESSION</h2>
        <p>
          If your content or account is reported for violating these Guidelines,
          then your content may be removed and/or your account may be suspended
          temporarily. In case of any subsequent violation, we may terminate
          your account with us and block you from registering with us.
          <br />
          <br />
          If required, we will cooperate with all legal and governmental
          authorities and we are under no duty to assist you.
        </p>
      </Container>
    </>
  )
}

export default ContentAndCommunityGuidelines
